import {FC} from 'react';
import {IconButton, styled, Typography} from '@mui/material';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {compact, get, join} from 'lodash';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {ImportDto} from '../../../../global/api';
import {format, parseISO} from 'date-fns';
import {DATETIME_FORMAT_FNS} from '../../../../shared/constants/date-formats';
import Status from '../../../../ui/status/Status';
import {ContractDataImportsDownloadButton} from './contract-data-imports-download-button';

interface Props {
  index: number;
  data: ImportDto;
  onToggleExpanded: () => void;
  expanded: boolean;
}

export const ContractDataImportsTableMainRow: FC<Props> = ({index, data, onToggleExpanded, expanded}) => {
  const initiator = get(data, 'initiator');
  const sourceDocument = get(data, 'sourceDocument');
  const statusCode = get(data, 'statusCode');

  return (
    <TableRow selected={expanded}>
      <StyledTableCell>
        <IconButton size="small" onClick={onToggleExpanded}>
          {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </StyledTableCell>
      <StyledTableCell align="center">{index}</StyledTableCell>
      <StyledTableCell align="left">
        <ContractDataImportsDownloadButton
          fileName={get(sourceDocument, 'fileName')}
          documentId={get(sourceDocument, 'id')}
        />
      </StyledTableCell>
      <StyledTableCell align="center">
        <StyledTypography>{parseDate(data.importStartDate)}</StyledTypography>
      </StyledTableCell>
      <StyledTableCell align="center">
        <StyledTypography>{parseDate(data.importFinishDate)}</StyledTypography>
      </StyledTableCell>
      <StyledTableCell align="center">
        <StyledTypography>
          {join(compact([initiator?.lastName, initiator?.firstName, initiator?.patronymic]), ' ') || '-'}
        </StyledTypography>
      </StyledTableCell>
      <StyledTableCell align="center">
        {statusCode ? <Status variant="subtitle2" entity="serviceRequestImport" code={statusCode} /> : '-'}
      </StyledTableCell>
    </TableRow>
  );
};

function parseDate(date?: string) {
  return !date ? '-' : format(parseISO(date), DATETIME_FORMAT_FNS);
}

const StyledTableCell = styled(TableCell)<{noPadding?: boolean}>({
  '.MuiTableCell-root:not(.MuiTableCell-root + .MuiTableRow-root)': {
    borderBottom: 0,
  },
});

const StyledTypography = styled(Typography)({
  fontSize: 13,
  fontWeight: 400,
});
